import React from 'react';
import { FileText, DollarSign } from 'lucide-react';
import '../styles/Modal.css';

function InvoiceTypeModal({ onSelectType, onClose }) {
  return (
    <div className="modal-overlay">
      <div className="modal invoice-type-modal">
        <div className="modal-header">
          <h2>Create New Invoice</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="invoice-type-container">
          <p className="modal-description">Select the type of invoice you want to create:</p>

          <div className="invoice-type-options">
            {/* WITH GST OPTION */}
            <div 
              className="invoice-type-card"
              onClick={() => onSelectType('with-gst')}
            >
              <div className="type-icon gst">
                <FileText size={40} />
              </div>
              <h3>With GST Invoice</h3>
              <p className="type-description">
                Standard invoice with full GST calculations (CGST, SGST, IGST)
              </p>
              <ul className="type-features">
                <li>✓ GST Compliance</li>
                <li>✓ CGST/SGST Calculations</li>
                <li>✓ IGST Support</li>
                <li>✓ Tax Breakdown</li>
              </ul>
              <button className="btn btn-primary full-width">
                Continue
              </button>
            </div>

            {/* WITHOUT GST OPTION */}
            <div 
              className="invoice-type-card"
              onClick={() => onSelectType('without-gst')}
            >
              <div className="type-icon no-gst">
                <DollarSign size={40} />
              </div>
              <h3>Without GST Bill</h3>
              <p className="type-description">
                Simple bill without GST, for non-taxable items or exempt customers
              </p>
              <ul className="type-features">
                <li>✓ No Tax Calculations</li>
                <li>✓ Simple Billing</li>
                <li>✓ Direct Amount</li>
                <li>✓ Quick Processing</li>
              </ul>
              <button className="btn btn-secondary full-width">
                Continue
              </button>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default InvoiceTypeModal;
